import styled from 'styled-components/macro';
import { FlexAlignRight, FlexJustifyCenter } from '../../../../../shared-styles/flex';

export const ModalText = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(20)};
  white-space: pre-wrap;
`;

export const ButtonContainer = styled.div`
  height: 40px;
  margin-top: ${(props) => props.theme.spacing(10)};
  ${FlexAlignRight}
  button:not(:first-child) {
    margin-left: ${(props) => props.theme.spacing(15)};
  }
`;

export const LoadContent = styled.div`
  margin-top: ${(props) => props.theme.spacing(20)};
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter};
`;

export const ModalContent = styled.div`
  width: 480px;
`;
